module.exports = __webpack_public_path__ + "static/media/wear-masks.ca843dc1.svg";